package fi.bullpen.kmpapp.data.turnkey.dto

import kotlinx.serialization.Serializable

@Serializable
abstract class TurnkeyQueryRequestBody {
    abstract val organizationId: String
}